import {useEffect, useState} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {SwalAlertClass} from "core/swalClass";
import Form from "react-bootstrap/Form";
import Offcanvas from "react-bootstrap/Offcanvas";
import axiApi from "ApiCaller";
import FormButton from "components/buttons/FormButton";
import {TelegramUsersModel} from "site-apps/authuser/TelegramUsersModel";
import Swal from "sweetalert2";
import {subscribeEvent, unsubscribeEvent} from "core/eventsConnector";
import ModalSelectPlatformUser from "./ModalSelectPlatformUser";

const FormTelegramUser = ({setShowCanvas, showCanvas, item, items, setItem, setItemsShown, organizations, panels, reloadData}) => {
    const [formData, setFormData] = useState(item);
    const [isNew, setIsNew] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isVerified, setIsVerified] = useState(false);
    const [showUserModal, setShowUserModal] = useState(false);
    const [platformUser, setPlatformUser] = useState(null);
    const Alert = new SwalAlertClass({confirmButtonText: "Aceptar"});

    useEffect(() => {
        setIsNew(!item.id);
        setIsVerified(item.is_verified || false);
        const itemData = {
            ...item,
            user_id: item.user || null,
        };
        setFormData(itemData);
        if (item.user) {
            const nameParts = (item.user_name || "").split(" ");
            const fName = nameParts[0] || item.user_email || "";
            const lName = nameParts.slice(1).join(" ") || "";
            setPlatformUser({id: item.user, user_email: item.user_email, first_name: fName, last_name: lName});
        } else {
            setPlatformUser(null);
        }
    }, [item]);

    useEffect(() => {
        const handler = (selected) => {
            if (selected) {
                setPlatformUser({id: selected.user, user_email: selected.detail.email, first_name: selected.detail.first_name, last_name: selected.detail.last_name});         
                setFormData((prev) => ({
                    ...prev,
                    user_id: selected.detail.id,
                    first_name: selected.detail.first_name || prev.first_name || "",
                    last_name: selected.detail.last_name || prev.last_name || "",
                    user_email: selected.detail.email || prev.user_email || "",
                }));
            }
        };
        subscribeEvent("telegram:modalselect:change", handler);
        return () => unsubscribeEvent("telegram:modalselect:change", handler);
    }, []);


    const handleChange = (event) => {
        const {name, value} = event.target;
        let data = {...formData};
        switch (name) {
            case "organizations":
                if (!formData.organizations.includes(value)) {
                    data.organizations.push(value);
                } else {
                    data.organizations = formData.organizations.filter((tok) => tok !== value);
                    let panelsToDelete = [];
                    panels.forEach((panel) => panel.org === value && panelsToDelete.push(panel.token));
                    data.panels = formData.panels.filter((token) => !panelsToDelete.includes(token));
                }
                if (data.organizations.length === 0) {
                    Alert.warning("Error", "Debe seleccionar al menos una organización.");
                    return false;
                }
                break;
            case "panels":
                if (!formData.panels.includes(value)) {
                    data.panels.push(value);
                } else {
                    data.panels = formData.panels.filter((tok) => tok !== value);
                }
                if (data.panels.length === 0) {
                    Alert.warning("Error", "Debe seleccionar al menos un panel.");
                    return false;
                }
                break;
            case "is_active":
            case "notifications_enabled":
                data[name] = !data[name];
                break;
            default:
                data[name] = value;
        }
        setFormData(data);
    };

    const handleClose = () => {
        setShowCanvas(false);
    };

    const checkErrorsForm = () => {
        let message = "";
        if (!formData.organizations.length) {
            message += "Debe seleccionar al menos una organización.\n";
        }
        if (!formData.panels.length) {
            message += "Debe seleccionar al menos un panel.\n";
        }
        if (message) {
            Alert.warning("Errores en el formulario", message);
        }
        return Boolean(message);
    };

    const onSubmit = (e) => {
        e.preventDefault();
        if (checkErrorsForm()) return false;

        setIsLoading(true);
        axiApi
            .post("/api/telegram/users/save/", formData)
            .then((resp) => {
                if (resp.data.status) {
                    let indexInAll = null;
                    items.current.all.forEach((item, idx) => {
                        if (item.id === resp.data.item.id) {
                            indexInAll = idx;
                            return false;
                        }
                    });
                    if (indexInAll !== null) {
                        items.current.all[indexInAll] = resp.data.item;
                    } else {
                        items.current.all.push(resp.data.item);
                    }
                    setItemsShown([...items.current.showed]);
                    handleClose();
                    reloadData();
                } else {
                    Alert.warning("Error al guardar", resp.data.message);
                }
            })
            .catch((error) => {
                console.error("Error al enviar la solicitud:", error);
                Alert.warning("Error", "Error en el servidor. Avise al administrador");
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const handleCopyLink = () => {
        if (formData.invitation_link) {
            const textarea = document.createElement("textarea");
            textarea.value = formData.invitation_link;
            textarea.style.position = "fixed";
            textarea.style.opacity = "0";
            document.body.appendChild(textarea);
            textarea.select();
            document.execCommand("copy");
            document.body.removeChild(textarea);
            Alert.info("Copiado", "Enlace de invitación copiado al portapapeles");
        }
    };

    const handleRegenerateLink = () => {
        Swal.fire({
            icon: "question",
            title: "¿Regenerar enlace?",
            text: "Se generará un nuevo enlace de invitación. El anterior dejará de funcionar.",
            showCancelButton: true,
            confirmButtonText: "Regenerar",
            cancelButtonText: "Cancelar",
        }).then((result) => {
            if (result.isConfirmed) {
                setIsLoading(true);
                axiApi
                    .post("/api/telegram/users/regenerate-invitation/", {id: formData.id})
                    .then((resp) => {
                        if (resp.data.status) {
                            setFormData({...resp.data.item});
                            Alert.info("Enlace regenerado", "Nuevo enlace de invitación generado.");
                        }
                    })
                    .catch(() => {
                        Alert.warning("Error", "Error al regenerar el enlace.");
                    })
                    .finally(() => {
                        setIsLoading(false);
                    });
            }
        });
    };

    const handleUnlink = () => {
        Swal.fire({
            icon: "warning",
            title: "¿Desvincular usuario?",
            text: "Se eliminará la vinculación de Telegram. Se generará un nuevo enlace de invitación para que el usuario se vuelva a vincular.",
            showCancelButton: true,
            confirmButtonText: "Desvincular",
            confirmButtonColor: "#dc3545",
            cancelButtonText: "Cancelar",
        }).then((result) => {
            if (result.isConfirmed) {
                setIsLoading(true);
                axiApi
                    .post("/api/telegram/users/save/", {...formData, unlink: true})
                    .then((resp) => {
                        if (resp.data.status) {
                            setFormData({...resp.data.item});
                            setIsVerified(false);
                            Alert.info("Desvinculado", "Usuario desvinculado. Nuevo enlace de invitación generado.");
                            reloadData();
                        }
                    })
                    .catch(() => {
                        Alert.warning("Error", "Error al desvincular.");
                    })
                    .finally(() => {
                        setIsLoading(false);
                    });
            }
        });
    };

    const title = formData.display_name || formData.telegram_username || formData.user_email || "Nuevo usuario de Telegram";

    return (
        <>
            <Offcanvas
                show={showCanvas}
                onHide={handleClose}
                placement="end"
                backdrop="false"
                scroll={true}
                style={{width: "35%"}}>
                <Offcanvas.Header className="preview-canvas" closeButton>
                    <div className="preview-icon">
                        <FontAwesomeIcon icon="people-group" />
                    </div>
                    <div className="preview-title">
                        <Offcanvas.Title>{title}</Offcanvas.Title>
                    </div>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <Form onSubmit={onSubmit} className="">
                        {/* Activo */}
                        <div className="row mb-2">
                            <div className="col-md-5 text-md-end">
                                <label className="text-danger fw-bold d-flex align-items-center justify-content-end">
                                    <FontAwesomeIcon icon="check-circle" className="me-2" />
                                    Activo
                                </label>
                            </div>
                            <div className="col-md-7">
                                <Form.Check
                                    id="is_active"
                                    name="is_active"
                                    checked={formData.is_active}
                                    onChange={handleChange}
                                    className="form-check-lg"
                                />
                            </div>
                        </div>
                        <hr className="col-10 m-auto mb-4" />

                        {/* Nombre */}
                        <div className="row">
                            <div className="col-md-5 text-md-end mt-2">
                                <label>Nombre:</label>
                            </div>
                            <div className="col-md-7">
                                <input
                                    type="text"
                                    className="form-control mb-2"
                                    id="first_name"
                                    name="first_name"
                                    value={formData.first_name || ""}
                                    onChange={handleChange}
                                    placeholder=""
                                />
                            </div>
                        </div>

                        {/* Apellido */}
                        <div className="row">
                            <div className="col-md-5 text-md-end mt-2">
                                <label>Apellido:</label>
                            </div>
                            <div className="col-md-7">
                                <input
                                    type="text"
                                    className="form-control mb-2"
                                    id="last_name"
                                    name="last_name"
                                    value={formData.last_name || ""}
                                    onChange={handleChange}
                                    placeholder=""
                                />
                            </div>
                        </div>

                        {/* Descripción */}
                        <div className="row">
                            <div className="col-md-5 text-md-end mt-2">
                                <label>Descripción:</label>
                            </div>
                            <div className="col-md-7">
                                <textarea
                                    className="form-control mb-2"
                                    id="description"
                                    name="description"
                                    rows="2"
                                    value={formData.description || ""}
                                    onChange={handleChange}
                                    placeholder=""
                                />
                            </div>
                        </div>

                        <hr className="col-10 m-auto mb-4" />

                        {/* Usuario de Plataforma */}
                        <div className="row">
                            <div className="col-md-5 text-md-end mt-2">
                                <label className="fw-bold">Usuario de Plataforma:</label>
                            </div>
                            <div className="col-md-7 mb-4">
                                {platformUser ? (
                                    <div>
                                        <div className="fw-bold">{platformUser.email || platformUser.user_email}</div>
                                        <div className="text-muted small">
                                            {[platformUser.first_name, platformUser.last_name].filter(Boolean).join(" ") || "—"}
                                        </div>
                                        <button
                                            type="button"
                                            className="btn btn-outline-danger btn-sm mt-1"
                                            onClick={() => {
                                                setPlatformUser(null);
                                                setFormData((prev) => ({...prev, user_id: 0}));
                                            }}>
                                            <FontAwesomeIcon icon="ban" className="me-1" />
                                            Quitar
                                        </button>
                                    </div>
                                ) : (
                                    <div>
                                        <span className="text-muted fst-italic">No vinculado</span>
                                        <br />
                                        <button
                                            type="button"
                                            className="btn btn-outline-primary btn-sm mt-1"
                                            onClick={() => setShowUserModal(true)}>
                                            <FontAwesomeIcon icon="user" className="me-1" />
                                            Seleccionar
                                        </button>
                                    </div>
                                )}
                            </div>
                        </div>

                        <hr className="col-10 m-auto mb-4" />

                        {/* Datos de Telegram (solo informativo) */}
                        <div className="row">
                            <div className="col-md-5 text-md-end mt-2">
                                <label>Usuario Telegram:</label>
                            </div>
                            <div className="col-md-7 mt-2">
                                {formData.telegram_username ? (
                                    <span className="fw-bold">@{formData.telegram_username}</span>
                                ) : (
                                    <span className="text-muted fst-italic">Pendiente</span>
                                )}
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-5 text-md-end mt-2">
                                <label>Telegram ID:</label>
                            </div>
                            <div className="col-md-7 mt-2">
                                {formData.telegram_id ? (
                                    <span className="fw-bold">{formData.telegram_id}</span>
                                ) : (
                                    <span className="text-muted fst-italic">Pendiente</span>
                                )}
                            </div>
                        </div>

                        {/* Verificado */}
                        <div className="row">
                            <div className="col-md-5 text-md-end mt-2">
                                <label>Estado:</label>
                            </div>
                            <div className="col-md-7 mt-2">
                                {isVerified ? (
                                    <span className="text-primary fw-bold">
                                        <FontAwesomeIcon icon="check-circle" className="me-1" />
                                        Vinculado
                                    </span>
                                ) : (
                                    <span className="text-primary fw-bold">
                                        <FontAwesomeIcon icon="clock" className="me-1" />
                                        Pendiente de vinculación
                                    </span>
                                )}
                            </div>
                        </div>

                        {/* Notificaciones */}
                        <div className="row mt-2">
                            <div className="col-md-5 text-md-end">
                                <label className="fw-bold">Notificaciones:</label>
                            </div>
                            <div className="col-md-7">
                                <Form.Check
                                    id="notifications_enabled"
                                    name="notifications_enabled"
                                    checked={formData.notifications_enabled}
                                    onChange={handleChange}
                                    className="form-check-lg"
                                />
                            </div>
                        </div>

                        <hr className="col-10 m-auto mb-4 mt-4" />

                        {/* Enlace de invitación - solo si NO está verificado */}
                        {!isVerified && formData.invitation_link && (
                            <>
                                <div className="row">
                                    <div className="col-12">
                                        <label className="fw-bold">Enlace de invitación:</label>
                                    </div>
                                </div>
                                <div className="row mt-2">
                                    <div className="col-12">
                                        <div className="input-group">
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={formData.invitation_link}
                                                readOnly
                                                onClick={(e) => e.target.select()}
                                            />
                                            <button type="button" className="btn btn-outline-secondary" onClick={handleCopyLink} title="Copiar">
                                                <FontAwesomeIcon icon="copy" />
                                            </button>
                                        </div>
                                        <small className="text-muted">
                                            Comparte este enlace para que el usuario se vincule automáticamente al abrirlo en Telegram.
                                        </small>
                                    </div>
                                </div>
                                <div className="row mt-2">
                                    <div className="col-12">
                                        <button type="button" className="btn btn-sm btn-outline-primary" onClick={handleRegenerateLink}>
                                            <FontAwesomeIcon icon="rotate-right" className="me-1" />
                                            Regenerar enlace
                                        </button>
                                    </div>
                                </div>
                                <hr className="col-10 m-auto mb-4 mt-4" />
                            </>
                        )}

                        {/* Botón desvincular - solo si está verificado */}
                        {isVerified && (
                            <>
                                <div className="row">
                                    <div className="col-12 text-center">
                                        <button
                                            type="button"
                                            className="btn btn-outline-primary btn-sm"
                                            onClick={handleUnlink}
                                            disabled={isLoading}>
                                            <FontAwesomeIcon icon="unlink" className="me-1" />
                                            Desvincular
                                        </button>
                                        <div className="mt-1">
                                            <small className="text-muted">
                                                Al desvincular se eliminará la conexión con Telegram <br /> y se generará un nuevo enlace de invitación.
                                            </small>
                                        </div>
                                    </div>
                                </div>
                                <hr className="col-10 m-auto mb-4 mt-4" />
                            </>
                        )}

                        {/* Organizaciones */}
                        <div className="row mt-2">
                            <div className="col-md-5 text-md-end">
                                <label className="fw-bold">Organizaciones:</label>
                            </div>
                            <div className="col-md-7 pt-3 border-top">
                                {organizations.map((org, idx) => (
                                    <div className="col-md-12" key={idx}>
                                        <Form.Check
                                            type="checkbox"
                                            name="organizations"
                                            value={org.token}
                                            label={org.name}
                                            checked={formData.organizations.includes(org.token)}
                                            onChange={handleChange}
                                        />
                                    </div>
                                ))}
                                {organizations.length === 0 && (
                                    <span className="text-muted fst-italic">No hay organizaciones disponibles</span>
                                )}
                            </div>
                        </div>

                        {/* Paneles */}
                        <div className="row mt-3">
                            <div className="col-md-5 text-md-end">
                                <label className="fw-bold">Paneles:</label>
                            </div>
                            <div className="col-md-7 pt-3 border-top">
                                {panels.map((mun, idx) =>
                                    formData.organizations.includes(mun.org) ? (
                                        <div className="col" key={idx}>
                                            <Form.Check
                                                type="checkbox"
                                                name="panels"
                                                value={mun.token}
                                                label={mun.name + " (" + mun.organization_name + ")"}
                                                disabled={!formData.organizations.includes(mun.org)}
                                                checked={formData.panels.includes(mun.token)}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    ) : ("")
                                )}
                                {panels.length === 0 && (
                                    <span className="text-muted fst-italic">No hay paneles disponibles</span>
                                )}
                            </div>
                        </div>

                        {/* Botones */}
                        <div className="row fixed-bottom me-3">
                            <div className="text-end col-12 mb-4">
                                <button type="button" className="btn btn-secondary me-4" onClick={handleClose}>
                                    Cancelar
                                </button>
                                <FormButton type="submit" className="btn btn-primary" isProcessing={isLoading}>
                                    Guardar
                                </FormButton>
                            </div>
                        </div>
                    </Form>

                    <ModalSelectPlatformUser
                        show={showUserModal}
                        setShow={setShowUserModal}
                    />
                </Offcanvas.Body>
            </Offcanvas>
        </>
    );
};

export default FormTelegramUser;
